/**
 * Lightweight modal shell (no shadcn dialog dependency to keep this isolated).
 *
 * Closes on Escape and on backdrop click. Children render the form/content.
 */
import { useEffect } from "react";
import { X } from "@phosphor-icons/react";

export default function Modal({ open, onClose, title, children, footer, testId }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm px-4 py-8"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        data-testid={testId || "modal"}
        className="w-full max-w-2xl rounded-2xl bg-white shadow-xl flex flex-col max-h-[90vh] overflow-hidden"
      >
        <header className="flex items-center justify-between gap-4 px-6 py-4 border-b border-slate-200">
          <h2 className="font-heading text-lg font-bold tracking-tight text-slate-900">
            {title}
          </h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Fermer"
            data-testid={testId ? `${testId}-close` : "modal-close"}
            className="p-1 -m-1 text-slate-500 hover:text-slate-900"
          >
            <X size={18} weight="bold" />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto px-6 py-5">{children}</div>
        {footer && (
          <footer className="border-t border-slate-200 px-6 py-4 flex justify-end gap-2 bg-slate-50">
            {footer}
          </footer>
        )}
      </div>
    </div>
  );
}
